import type { FaireProductEntity } from "../../entity_types/product";

export const p_93rtbpawna: FaireProductEntity = {
  token: "p_93rtbpawna",
  type: "product",
  name: "Juniper Champagne / Prosecco / Cava Tulip Glass / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/f9ad6a487bb166b344e0517074f10a0bcee2d91bad300e23bc29cfd4c8e35196.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a51942364731e7828af56aa7f575813efe7144d4d0914601a2fd6f579ca355c.jpeg",
  ],
  priceDollars: 26.25,
  description:
    'JUNIPER is a sculptural glassware range designed to elevate the drinking experience by enhancing both flavour and aroma. The glasses are graphic in form yet functional and satisfying to use, and their striking geometric silhouette adds interest to any table, bar or drinks trolley.\n\nJuniper Champagne / Prosecco / Cava Tulip Glass\n• Size: Ø 7.5cm x H 23cm / Ø 2.95" x H 9"\n• Capacity: 250 ml / 8.5 fl oz\n\n• Packed as a set of 2\n\n• Colour: clear',
  tags: [],
  msrpDollars: 52.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:32.771Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
